// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__28pE7","active":"Footer_active__1Y7Ga","footerLink":"Footer_footerLink__1TbfF","footerContent":"Footer_footerContent__1udeC"};